import { ControlTemplate } from 'dac-web-ui';
import { GridAqua } from '../structures/aqua/gridAqua';

export class AquaManager extends ControlTemplate {
	constructor( modules, managers ) {
		super();
		this.modules = modules;
		this.managers = managers;
		this.managers.AquaManager = this;

		this.gridAqua = null;
		this.answers = {
			normales: [],
			capilla: [],
			transversales: [],
			puntofijo: [],
			zona: [],
			frontalNorte: [],
			frontalSur: [],
			lateralEste: [],
			lateralOeste: []			//TODO: cuales más?
		};
	}

	parseGrid( grid ) {
		if( this.gridAqua ) return;
		this.gridAqua = new GridAqua().fromGrid( grid );	//TODO: pass project id
	}
	
	clearGrid() {
		if( !this.gridAqua ) return;
		this.gridAqua.clear();
		this.gridAqua = null;
	}
}